import React, { Component } from 'react'

class ProfileCard extends Component {
  render() {
    const { image, role, name, education, width } = this.props
    let size = 200
    if (width < 500) size = 100
    else if (width < 1200) size = 150
    return (
      <div style={{ marginTop: 25, width: size }}>
        <img alt="Head" src={image} style={{ width: size, height: size }} />
        <p>{name}</p>
        <p style={{ color: '#a9a9a9', fontSize: 14 }}>{role}</p>
        <p style={{ color: '#a9a9a9', fontSize: 14 }}>{education}</p>
      </div>
    )
  }
}

export { ProfileCard }



// WEBPACK FOOTER //
// ./src/components/common/ProfileCard.js